'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  config: _propTypes2.default.shape({
    useMinimalHeader: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    minimalHeader: _propTypes2.default.shape({
      labelMenuButton: _propTypes2.default.string.isRequired,
      labelClose: _propTypes2.default.string.isRequired,
      logo: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired
      }),
      headerButtons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string,
        text: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired,
        color: _propTypes2.default.oneOf(['outline-white', 'white'])
      }))
    }),
    mainMenuContent: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string,
      type: _propTypes2.default.oneOf(['linkOnly', 'linkOnlyDesk', 'subnav', 'subnavGrouped', 'sendMoneyForm', 'languageDesk', 'languageMobile']),
      text: _propTypes2.default.string,
      href: _propTypes2.default.string,
      subnavLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _propTypes2.default.string,
        subtext: _propTypes2.default.string,
        href: _propTypes2.default.string
      })),
      subnavLinksL2: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _propTypes2.default.string,
        href: _propTypes2.default.string
      }))
    })),
    sublistMobile: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      type: _propTypes2.default.oneOf(['link', 'cta']),
      text: _propTypes2.default.string,
      href: _propTypes2.default.string
    }))
  })
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/components/MPPHeaderPropTypes.js
// module id = 499
// module chunks = 4